import React from 'react'
import SlickSlider from "react-slick";
import Slide from "./Slide";

/*
  TODO
  This component is not enough generic (can't be used in another page with other elements)
  We could call the same datas that for ClientCases ?
  We could add settings in props ?
*/

/**
  * @class Slider
  * Settings and load datas for a slider
*/
class Slider extends React.Component {

  settings: object[] = []

  constructor(props) {
    super(props);
    this.state = {
      slides: [],
      isLoading: false,
      error: null
    }

    // Settings for react-slick
    // see https://react-slick.neostack.com/docs/api for all the possibilities
    this.settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 4000,
      pauseOnHover: false,
      pauseOnDotsHover: true
    }
  }

  componentDidMount() {
    this.setState({isLoading: true})

    // Fix ASAP
    // Create custom API endpoint to retrieve major cases and other posts to display in the slider.
    let slides = [];

    // Retrieve the "30-ans" page and add it to the slider as the first slide.
    // Retrieve all cases and keep only major cases to display in the slider.
    fetch(`${process.env.REACT_APP_PUBLIC_API_URL}/wp/v2/cas_clients/?orderby=menu_order&order=asc`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json; charset=UTF-8"
      }
    })
      .then(response => {
        if (response.ok) {
          return response.json()
        } else {
          throw new Error("Une erreur s'est produite.")
        }
      })
      .then(articles => {
        articles.forEach(article => {
          // Keep only major cases with slider on.
          if (article.acf
            && article.acf.slider
            && article.acf.slider === '1'
            && article.acf.caseType
            && article.acf.caseType === '1'
          ) {
            slides.push({
              thumbnail: article.acf.slider_visual,
              thumbnailLabel: `Étude de cas ${article.acf.client}`,
              button_label: `Découvrez le case study ${article.title}`,
              route: `/cas-client-${article.slug}`,
              baseline: article.acf.baseline,
            });
          }
        })
      })
      .then(() => {
        // Check for post "30 ans" if it needs to be displayed in the slider.
        fetch(`${process.env.REACT_APP_PUBLIC_API_URL}/wp/v2/posts?slug=30-ans`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        })
          .then(response => {
            if (response.ok) {
              return response.json()
            } else {
              throw new Error("Une erreur s'est produite.")
            }
          })
          .then(articles => {
            const article = articles[0] || {};
            const fields = article.acf || {};
            // Add post in the slider.
            if (fields.slider && fields.slider === "1") {
              slides.unshift({
                thumbnail: fields.slider_visual,
                thumbnailLabel: fields.title,
                button_label: fields.slider_button_label || fields.title,
                route: "/30-ans",
                baseline: fields.baseline || fields.title,
              })
            }
            // Finally update slider state.
            this.setState({
              debug: articles,
              slides,
              isLoading: false
            });
          })
      })
      .catch(error => this.setState({error, isLoading: false}));
  }

  /**
    * @class Slider
    * @method getSlidesList
    * Calls Slide component for each object in slides
  */
  getSlidesList() {
    return this.state.slides.map((slide, index) =>
      <Slide key={index} slide={slide} />
    )
  }

  render() {
    return (
      <React.Fragment>
        {/* Call SlickSlider only if there is at least one slide */}
        {/* And add settings to SlickSlider component */}
        {this.state.slides.length > 0 &&
          <SlickSlider className="slider--home" {...this.settings}>
            { this.getSlidesList() }
          </SlickSlider>
        }
      </React.Fragment>
    )
  }
}

export default Slider



// WEBPACK FOOTER //
// ./src/components/Slider/index.jsx